export default __webpack_public_path__ + "static/media/portadavideoconfiguracion1.2760f179.png";